const Avg2 = [
    {id: "4", value: "5月，10月"},    
    {id: "0", value: "5月，20月"},    
    {id: "1", value: "5月，20月，60月"},
    {id: "2", value: "5月，10月，20天，60月"},
  ];  
  
  export default Avg2